export default "__VITE_ASSET__6ee34da3__"